import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  // url: 'https://keycloak.project1.ceg.dev.kutirmobility.com:8443',
  url: 'https://auth.ft-knox-lge-gas-consumption.com:8443',
  realm: 'users',
  clientId: 'frontend',
});

const doLogin = keycloak.login;
const doLogout = keycloak.logout;
const getToken = () => keycloak.token;
const updateToken = (successCallback: () => void) => {
  keycloak.updateToken(30)
    .then(successCallback)
    .catch(doLogin);
};

const getUserInfo = () => keycloak.loadUserInfo();

export {
  doLogin,
  doLogout,
  getToken,
  updateToken,
  getUserInfo,
  keycloak
};